import axios from "axios";
import { API_BASE_URL } from "../../globalVars";

export default {
  namespaced: true,

  actions: {
    async createListItem(context, listItem) {
      if (listItem.isDirty === true) {
        const store = this;
        try {
          const accountId = store.getters["entities/listItems/find"](1).id;
          let newListItemData = {
            accountId: accountId,
            listTypeId: listItem.listTypeId,
            name: listItem.name,
            rank: listItem.rank,
            meta: {}
          };
          if (listItem.meta) {
            if (listItem.meta.color) {
              newListItemData.meta.color = listItem.meta.color;
            }
            if (listItem.meta.value) {
              newListItemData.meta.value = listItem.meta.value;
            }
            if (listItem.meta.display) {
              newListItemData.meta.display = listItem.meta.display;
            }
            if (listItem.meta.flow) {
              newListItemData.meta.flow = listItem.meta.flow;
            }
            if (listItem.meta.uid) {
              newListItemData.meta.uid = listItem.meta.uid;
            }
          }
          let response = await axios({
            method: "post",
            url: API_BASE_URL + `/list-item`,
            data: newListItemData,
            headers: {
              Authorization: `Bearer ${localStorage.getItem("access_token")}`
            }
          });
          let updateListItem = {
            id: response.data.id,
            name: response.data.name,
            listTypeId: response.data.listTypeId,
            rank: response.data.rank,
            meta: {}
          };
          if (response.data.meta) {
            if (response.data.meta.color) {
              updateListItem.meta.color = response.data.meta.color;
            }
            if (response.data.meta.value) {
              updateListItem.meta.value = response.data.meta.value;
            }
            if (response.data.meta.display) {
              updateListItem.meta.display = response.data.meta.display;
            }
            if (response.data.meta.flow) {
              updateListItem.meta.flow = response.data.meta.flow;
            }
            if (response.data.meta.uid) {
              updateListItem.meta.uid = response.data.meta.uid;
            }
          }
          store.dispatch("entities/listItems/insert", {
            where: response.data.id,
            data: updateListItem
          });
          store.dispatch("entities/settings/setIsOffline", false);
        } catch (error) {
          store.dispatch("entities/settings/setIsOffline", true);
        }
      }
    },

    async updateListItem(context, listItem) {
      const store = this;
      const oldListItem = store.getters["entities/listItems/find"](
        listItem.id
      );
      if (
        !(
          oldListItem.name === listItem.name &&
          oldListItem.rank === listItem.rank &&
          oldListItem.listTypeId === listItem.listTypeId
        ) ||
        listItem.isDirty === true
      ) {
        try {
          const accountId = store.getters["entities/accounts/query"]().first().id;
          let newListItemData = {
            id: listItem.id,
            accountId: accountId,
            listTypeId: listItem.listTypeId,
            name: listItem.name,
            rank: listItem.rank,
            meta: {}
          };
          if (listItem.meta) {
            if (listItem.meta.color) {
              newListItemData.meta.color = listItem.meta.color;
            }
            if (listItem.meta.value) {
              newListItemData.meta.value = listItem.meta.value;
            }
            if (listItem.meta.display) {
              newListItemData.meta.display = listItem.meta.display;
            }
            if (listItem.meta.flow) {
              newListItemData.meta.flow = listItem.meta.flow;
            }
            if (listItem.meta.uid) {
              newListItemData.meta.uid = listItem.meta.uid;
            }
          }
          store.dispatch("entities/listItems/update", newListItemData);
          let response = await axios({
            method: "patch",
            url: API_BASE_URL + `/list-item/${newListItemData.id}`,
            data: newListItemData,
            headers: {
              Authorization: `Bearer ${localStorage.getItem("access_token")}`
            }
          });
          let updateListItem = {
            name: response.data.name,
            listTypeId: response.data.listTypeId,
            rank: response.data.rank,
            meta: {}
          };
          if (response.data.meta) {
            if (response.data.meta.color) {
              updateListItem.meta.color = response.data.meta.color;
            }
            if (response.data.meta.value) {
              updateListItem.meta.value = response.data.meta.value;
            }
            if (response.data.meta.display) {
              updateListItem.meta.display = response.data.meta.display;
            }
            if (response.data.meta.flow) {
              updateListItem.meta.flow = response.data.meta.flow;
            }
            if (response.data.meta.uid) {
              updateListItem.meta.uid = response.data.meta.uid;
            }
          }
          store.dispatch("entities/listItems/update", {
            where: response.data.id,
            data: updateListItem
          });
          store.dispatch("entities/settings/setIsOffline", false);
        } catch (error) {
          store.dispatch("entities/settings/setIsOffline", true);
        }
      }
    },

    async deleteListItem(context, listItem) {
      const store = this;
      store.dispatch("entities/listItems/delete", listItem.id);
      if (listItem.isDirty === true) {
        try {
          const accountId = store.getters["entities/accounts/query"]().first().id;
          await axios({
            method: "patch",
            url: API_BASE_URL + `/list-item/${listItem.id}`,
            data: {
              accountId: accountId,
              id: listItem.id,
              deleted: true
            },
            headers: {
              Authorization: `Bearer ${localStorage.getItem("access_token")}`
            }
          });
          store.dispatch("entities/settings/setIsOffline", false);
        } catch (error) {
          store.dispatch("entities/settings/setIsOffline", true);
        }
      }
    }
  }
};
